'use client';
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));

// components/theme/react/src/index.ts
import { createComponentClassDefinitions, createTheme, darkTheme, formatTokenName, generateCssVars as generateCssVars2, injectCssVars, injectFontsForTheme as injectFontsForTheme3, lightTheme as lightTheme3 } from "@gs-ux-uitoolkit-common/theme";

// components/theme/react/src/theme-provider.tsx
import { useEffect } from "react";

// components/theme/react/src/theme-context.tsx
import { createContext } from "react";
import { lightTheme } from "@gs-ux-uitoolkit-common/theme";
var ThemeContext = createContext(lightTheme);

// components/theme/react/src/analytics-tracking.ts
import { ComponentAnalytics } from "@gs-ux-uitoolkit-react/analytics";

// components/theme/react/src/version.ts
var name = "@gs-ux-uitoolkit-react/theme";
var version = "18.12.1                 ".trim();
var Version = { name, version };

// components/theme/react/src/analytics-tracking.ts
var componentAnalytics = new ComponentAnalytics({
  packageName: Version.name,
  version: Version.version
});
componentAnalytics.trackPackageLoad();

// components/theme/react/src/theme-provider.tsx
import { jsx } from "react/jsx-runtime";
var ThemeProvider = ({ theme, children }) => {
  useEffect(() => {
    componentAnalytics.track({
      officialComponentName: "other",
      eventName: "Rendered",
      featureName: "Theme",
      properties: {
        colorMode: theme.colorMode
      }
    });
  }, [theme]);
  return jsx(ThemeContext.Provider, { value: theme, children });
};

// components/theme/react/src/theme-consumer.tsx
import { injectFontsForTheme } from "@gs-ux-uitoolkit-common/theme";
import { useEmotionInstance } from "@gs-ux-uitoolkit-react/style";
import { jsx as jsx2 } from "react/jsx-runtime";
var ThemeConsumer = ({ children }) => {
  const emotionInstance = useEmotionInstance();
  return jsx2(ThemeContext.Consumer, { children: (theme) => {
    injectFontsForTheme(theme, { emotionInstance });
    return children(theme);
  } });
};

// components/theme/react/src/theme-container.tsx
import { useContext } from "react";
import {
  lightTheme as lightTheme2,
  generateCssVars
} from "@gs-ux-uitoolkit-common/theme";
import { styled } from "@gs-ux-uitoolkit-react/style";
import { jsx as jsx3 } from "react/jsx-runtime";
var CssVarContainer = styled(
  "div",
  ({
    theme,
    generateCssVars: shouldGenerateCssVars
  }) => {
    const cssVars = shouldGenerateCssVars ? generateCssVars(theme) : {};
    return __spreadValues({
      background: theme.surface.primary,
      color: theme.text.primary
    }, cssVars);
  }
);
var ThemeContainer = ({
  theme,
  children,
  className,
  generateCssVars: generateCssVars3
}) => {
  const contextTheme = useContext(ThemeContext);
  const themeValue = theme || contextTheme || lightTheme2;
  return jsx3(ThemeContext.Provider, { value: themeValue, children: jsx3(
    CssVarContainer,
    {
      theme: themeValue,
      generateCssVars: generateCssVars3,
      "data-gs-uitk-component": "theme-container",
      className,
      children
    }
  ) });
};

// components/theme/react/src/use-theme.tsx
import { useContext as useContext2 } from "react";
import { injectFontsForTheme as injectFontsForTheme2 } from "@gs-ux-uitoolkit-common/theme";
import { useEmotionInstance as useEmotionInstance2 } from "@gs-ux-uitoolkit-react/style";
function useTheme() {
  const theme = useContext2(ThemeContext);
  const emotionInstance = useEmotionInstance2();
  injectFontsForTheme2(theme, { emotionInstance });
  return theme;
}

// components/theme/react/src/with-theme-consumer.tsx
import { jsx as jsx4 } from "react/jsx-runtime";
function withTheme(WrappedComponent) {
  const displayName = WrappedComponent.displayName || WrappedComponent.name || "Component";
  const ComponentWithTheme = (props) => {
    const theme = useTheme();
    return jsx4(WrappedComponent, __spreadProps(__spreadValues({}, props), { theme }));
  };
  ComponentWithTheme.displayName = `withTheme(${displayName})`;
  return ComponentWithTheme;
}
export {
  ThemeConsumer,
  ThemeContainer,
  ThemeProvider,
  Version,
  createComponentClassDefinitions,
  createTheme,
  darkTheme,
  formatTokenName,
  generateCssVars2 as generateCssVars,
  injectCssVars,
  injectFontsForTheme3 as injectFontsForTheme,
  lightTheme3 as lightTheme,
  useTheme,
  withTheme
};
//# sourceMappingURL=index.mjs.map
